import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { RotateCcw, Mail, CheckCircle2, XCircle, DollarSign, Send } from 'lucide-react';

const RefundPolicy = () => {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div>
      <section className="bg-gradient-to-b from-[#efe9db] to-[#faf7f1]">
        <div className="max-w-4xl mx-auto px-6 py-16 md:py-24 text-center">
          <div className="inline-flex items-center gap-2 uppercase tracking-[0.35em] text-xs text-[#7a8b6b] mb-4">
            <RotateCcw className="w-4 h-4" /> 30-Day Money Back Guarantee
          </div>
          <h1 className="font-serif-elegant text-5xl md:text-6xl mb-4">Refund Policy</h1>
          <p className="text-[#4a4640] max-w-2xl mx-auto leading-relaxed">
            We want you to love your purchase. If for any reason you are not satisfied, we offer a
            30-Day Money Back Guarantee under the following conditions.
          </p>
        </div>
      </section>

      <div className="max-w-3xl mx-auto px-6 lg:px-10 py-12 space-y-10">
        <section>
          <div className="flex items-center gap-2 mb-3">
            <CheckCircle2 className="w-5 h-5 text-[#7a8b6b]" />
            <h2 className="font-serif-elegant text-3xl">Eligible Returns</h2>
          </div>
          <ul className="space-y-2 text-[#4a4640] leading-relaxed pl-7 list-disc">
            <li>Items must be returned within 30 days of the delivery date.</li>
            <li>Products may only be lightly used (1&ndash;2 times maximum). Items that are half-used or fully empty are not eligible for return.</li>
            <li>Product must be in its original packaging with proof of purchase (receipt or order number).</li>
          </ul>
        </section>

        <section>
          <div className="flex items-center gap-2 mb-3">
            <XCircle className="w-5 h-5 text-[#7a3b2e]" />
            <h2 className="font-serif-elegant text-3xl">Non-Returnable Items</h2>
          </div>
          <ul className="space-y-2 text-[#4a4640] leading-relaxed pl-7 list-disc">
            <li>Products used more than 2 times, mostly used, or empty.</li>
            <li>Sale items, gift cards, or promotional bundles.</li>
            <li>Items returned without authorization.</li>
          </ul>
        </section>

        <section>
          <div className="flex items-center gap-2 mb-3">
            <DollarSign className="w-5 h-5 text-[#7a8b6b]" />
            <h2 className="font-serif-elegant text-3xl">Refunds</h2>
          </div>
          <ul className="space-y-2 text-[#4a4640] leading-relaxed pl-7 list-disc">
            <li>Approved refunds will be issued back to your original payment method within 7&ndash;10 business days after we receive your return.</li>
            <li>Shipping costs are non-refundable unless the return is due to our error (wrong or defective item).</li>
          </ul>
        </section>

        <section>
          <div className="flex items-center gap-2 mb-3">
            <Send className="w-5 h-5 text-[#7a8b6b]" />
            <h2 className="font-serif-elegant text-3xl">How to Start a Return</h2>
          </div>
          <ol className="space-y-3 text-[#4a4640] leading-relaxed pl-7 list-decimal">
            <li>
              Email us at{' '}
              <a href="mailto:connectwithanherbalist@outlook.com" className="link-underline text-[#3a4a3b]">connectwithanherbalist@outlook.com</a>{' '}
              with your order number and reason for return.
            </li>
            <li>We will provide you with a Return Authorization and mailing instructions.</li>
            <li>Ship the product back in secure packaging.</li>
          </ol>
        </section>

        <section className="bg-[#efe9db] p-8 text-center">
          <Mail className="w-6 h-6 mx-auto text-[#3a4a3b] mb-3" />
          <h3 className="font-serif-elegant text-2xl mb-2">Need help with a return?</h3>
          <p className="text-[#4a4640] mb-4">Our team is here for you. We&rsquo;ll respond within 1&ndash;2 business days.</p>
          <a href="mailto:connectwithanherbalist@outlook.com" className="btn-primary inline-flex items-center gap-2">
            <Mail className="w-4 h-4" /> connectwithanherbalist@outlook.com
          </a>
        </section>

        <div className="text-center pt-6">
          <Link to="/collections/all" className="btn-outline">Back to Shop</Link>
        </div>
      </div>
    </div>
  );
};

export default RefundPolicy;
